<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap v-if="initStatus === 1">
        <v-flex xs12>
          <v-stepper :value="quoteLifeCycle" class="quoteLifeCycle">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="quoteLifeCycle > 1">General</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="quoteLifeCycle > 2">Shipment/Consignee</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="quoteLifeCycle > 3">Clauses</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4" :complete="quoteLifeCycle > 4">Applicant</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5" :complete="quoteLifeCycle > 5">Premium</v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </v-flex>
        <v-flex lg8 xs12 order-lg1 order-xs2>
          <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
          </transition>
          <!-- The following dialog will work with leaveQuote Mixin (individual module to follow this structure:: just change the title) -->
          <promptLeave title="Cargo" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
        </v-flex>
        <v-flex lg4 xs12 order-lg2 order-xs1>
          <cargo-quick-info></cargo-quick-info>
        </v-flex>
      </v-layout>
      <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Cargo Quotation Details..." errorText="Failed to load Cargo Quotation Details" :loading="initStatus === 0"></loader>
    </v-container>
  </div>
</template>

<script>
import PromptLeave from '../../shared/leaveQuote/PromptLeave'
import { leaveQuote } from '../../shared/leaveQuote'
import CargoQuickInfo from './CargoQuickInfo'

export default {
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quoteLifeCycle() {
      return this.$store.state.agency.quotation.quoteLifeCycle
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('cargoQuoteInit')
    },
    getVesselTonnageLabel(grt, nrt) {
      return 'GRT/NRT: ' + grt + '/' + nrt
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    PromptLeave,
    CargoQuickInfo
  },
  mixins: [
    leaveQuote
  ]
}
</script>

<style lang="scss">
</style>
